import { Component, OnInit } from '@angular/core';
import {GameService} from "../../services/game.service";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-games',
  templateUrl: './games.component.html',
  styleUrls: ['./games.component.css']
})
export class GamesComponent implements OnInit {
  games: any[] = [];
  skeletonItems = Array.from({ length: 12 });
  page: number = 1;
  filteredGames: any[] = [];
  currentSearch: string | null = null;
  searchTerm: string = '';
  gamesLoaded: boolean = false;
  totalPages: number = 1;
  itemsPerPage: number = 12;

  constructor(private gameService: GameService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    // Fetch games data from the service first
    this.fetchGames();

    // Subscribe to query parameters to get the current search term
    this.route.queryParams.subscribe(params => {
      this.currentSearch = params['search'] || null;
      // Keep the on-page field in step with the URL, so arriving from the
      // navbar search or a shared link shows the term that is being applied.
      this.searchTerm = this.currentSearch || '';
      if (this.gamesLoaded) {
        this.applyFilter();
      }
    });
  }

  /**
   * Called on every keystroke in the on-page search field.
   *
   * The URL is updated with replaceUrl so a shared link carries the search,
   * without pushing one history entry per character typed.
   */
  onSearchChange(): void {
    const term = this.searchTerm.trim();
    this.currentSearch = term || null;
    this.applyFilter();
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { search: term || null },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  clearSearch(): void {
    this.searchTerm = '';
    this.onSearchChange();
  }

  fetchGames() {
    this.gameService.getGames().subscribe(
        (data: any[]) => {
          this.games = data;
          this.gamesLoaded = true;
          // Apply filter if there's a search term
          if (this.currentSearch) {
            this.applyFilter();
          } else {
            this.filteredGames = this.games;
            this.calculateTotalPages();
          }
        },
        (error) => {
          console.error('Error fetching games:', error);
        }
    );
  }

  setCurrent(number: number) {
    this.page = number;
  }

  // Calculate total pages based on filtered games and items per page
  calculateTotalPages() {
    this.totalPages = Math.ceil(this.filteredGames.length / this.itemsPerPage);
  }

  // Navigate to previous page
  previousPage() {
    if (this.page > 1) {
      this.page--;
    }
  }

  // Navigate to next page
  nextPage() {
    if (this.page < this.totalPages) {
      this.page++;
    }
  }

  applyFilter(): void {
    if (this.currentSearch && this.currentSearch.trim()) {
      const searchLower = this.currentSearch.trim().toLowerCase();
      this.filteredGames = this.games.filter(game =>
          (game?.name || '').toLowerCase().includes(searchLower) ||
          (game?.genre || '').toLowerCase().includes(searchLower)
      );
    } else {
      this.filteredGames = this.games;
    }
    this.calculateTotalPages();
    this.page = 1; // Reset to first page when filter changes
  }

  routeToPage(page: string) {
    this.router.navigate([page]);
  }

  gameSlug(name: string): string {
    return (name || 'game')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }
}
